module.exports = __webpack_public_path__ + "static/media/img-day-of-week.fb322eb7.jpg";